export default function (param, encode) {
  if (!param)
    return '';
  var qstr = [];
  for (var key in param) {
    if (typeof param[key] != 'undefined' || param[key] != null) {
      qstr.push(key + '=' + (encode ? encodeURIComponent(param[key]) : param[key]));
    }
  }
  return qstr.join('&');
}
